import { Dispatch } from "redux";
import { createSlice } from "@reduxjs/toolkit";
import * as serverRequest from "../../_apis/NetworkCrud";

export interface NETWORK_INITIAL_STATE {
  error: boolean;
  isLoading: boolean;
  networksPayload: string[];
  selectedNetwork: any;
  connectedNetwork: any;
  supportedChainIds: string[];
}

const initialState: NETWORK_INITIAL_STATE = {
  error: false,
  isLoading: false,
  networksPayload: [],
  selectedNetwork: {},
  connectedNetwork: {},
  supportedChainIds: [],
};

const slice = createSlice({
  name: "networks",
  initialState,
  reducers: {
    startLoading(state) {
      state.isLoading = true;
    },

    hasError(state, action) {
      state.isLoading = false;
      state.error = action.payload;
    },

    setSelectedNetwork(state, action) {
      state.selectedNetwork = action.payload.selectedNetwork;
    },
    setConnectedNetwork(state, action) {
      state.connectedNetwork = action.payload;
    },

    getChainIds(state, action) {
      state.isLoading = false;
      state.networksPayload = action.payload.networksPayload;
      state.supportedChainIds = action.payload.supportedChainIds;
    },
  },
});

export default slice.reducer;

export const setSelectedNetwork = (data: any) => (dispatch: Dispatch) => {
  dispatch(slice.actions.setSelectedNetwork(data));
};

export const setConnectedNetwork = (data: any) => (dispatch: Dispatch) => {
  dispatch(slice.actions.setConnectedNetwork(data));
};

export const getNetworkByChainId = (chainId: string) => {
  return serverRequest.getNetworkInformationForPublicUser(chainId);
};
export const getNetworksList = () => (dispatch: Dispatch) => {
  dispatch(slice.actions.startLoading());

  serverRequest
    .getAllNetworksApi()
    .then((res) => {
      let networkList = res.data.body.networks;
      let chainIds: number[] = [];
      let networks: string[] = [];
      networkList &&
        networkList.length &&
        networkList.forEach((network: any) => {
          chainIds.push(Number(network.chainId));
        });
      networkList &&
        networkList.length &&
        networkList.forEach((network: any) => {
          networks.push({
            ...network,
            networkName: network.name,
            image: network.logo,
          });
        });
      dispatch(
        slice.actions.getChainIds({
          networksPayload: networks,
          supportedChainIds: chainIds,
        })
      );
    })
    .catch((e) => {
      if (e.response) {
        dispatch(slice.actions.hasError(e.response?.data?.status?.message));
      } else {
        dispatch(
          slice.actions.hasError("Something went wrong. Try again later!")
        );
      }
    });
};
